export default __webpack_public_path__ + "static/media/prenatal.c9abb71b.jpg";